import { useNavigate } from 'react-router-dom'
import { useUserProfile } from '@/presentation/hooks/useUserProfile'
import { useTeamMembers } from './useTeamMembers'

export function useTeamViewModel() {
  const navigate = useNavigate()
  const { userProfile, isUserProfileLoading } = useUserProfile()
  const { teamStats, isTeamLoading } = useTeamMembers()

  const handleInvite = () => {
    navigate('/invite')
  }

  return {
    greeting: {
      nickname: userProfile?.nickname,
      isLoading: isUserProfileLoading,
    },
    stats: {
      totalMembers: teamStats?.totalMembers || 0,
      isLoading: isTeamLoading,
      onInvite: handleInvite,
    },
    memberList: {
      members: teamStats?.recentMembers || [],
      isLoading: isTeamLoading,
      onInvite: handleInvite,
    },
  }
}
